define [], () ->
  ($state, $rootScope, $window, Landlord) ->
    template: require("./tapfiliate.jade")
    restrict: "A"
    link: (scope, element, attrs) ->
      $rootScope.$on "landlord-conversion", (event, data) ->
        $window.tap('conversion', data.user_id, null, {meta_data: {email: data.user_email}}, null, (conversion) ->
          Landlord.update({id: 'me', conversion_id: conversion.id.toString() }).$promise
            .then () ->
              console.log('Updated with conversion_id!')
            .catch (err) ->
              console.log(err)
        )



// WEBPACK FOOTER //
// ./directives/tapfiliate/tapfiliate.coffee